
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DatoExtendidoForm from '@/pantallas/Dispositivos/DatoExtendidoForm.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import {
  emitFormChangeEvent,
  FormChangeEvent,
  formErrors,
  FormErrors,
  FormFieldDefMap,
  FormState,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import {
  DatoExtendidoNuevo,
  DatoExtendido,
} from '@/pantallas/Dispositivos/Dispositivos';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate/types/vee-validate';
import Confirmation from '@/components/Confirmation.vue';
import MensajeValidacion from '@/reusable/Mantenedor/MensajeValidacion.vue';
type CrearTipoDatoExtendidoFormState = {
  entity: DatoExtendidoNuevo;
  validator: Validator;
  isDirty: boolean;
};

@Component({
  components: {
    Confirmation,
    CabeceraModal,
    DatoExtendidoForm,
    ModalMantenedor,
    GuardarButton,
    MensajeValidacion,
  },
})
export default class CrearTipoDatoExtendidoModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) datoExtendido: DatoExtendido[];
  @Prop({ required: false }) dispositivoId: number;

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };
  form: CrearTipoDatoExtendidoFormState = {
    entity: null,
    validator: null,
    isDirty: null,
  };
  dialogConfirmacionClose: boolean = false;
  disableBtnContinuar: boolean = false;
  hasErrors = false;
  isValid = false;
  dialogConfirmacion: boolean = false;
  mensajeConfirmacionInactivo: any = '';
  showValidacion: boolean = false;

  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  /* event handlers */

  handleCerrar() {
    this.dialogConfirmacionClose = true;
  }

  handleCierreConfirmacionCerrar(isConfirmado: boolean) {
    this.dialogConfirmacionClose = false;
    if (!isConfirmado) {
      return;
    }
    this.$emit('cerrar');
  }

  async handleGuardarClick() {
    this.isValid = await this.form.validator.validateAll();
    if (this.isValid) {
      if (this.form.entity.scriptMostrar != '') {
        this.hasErrors = true;
        this.mensajeConfirmacionInactivo =
          '¿Está seguro que desea agregar el Dato Extendido al Dispositivo?';
        this.dialogConfirmacion = true;
      } else {
        this.showValidacion = true;
      }
    } else {
      this.form.isDirty = true;
      this.hasErrors = true;
    }
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;
    this.hasErrors = false;
    if (val) {
      this.$emit('cerrarBtnGuardar', {
        entity: this.form.entity as DatoExtendidoNuevo,
      });
      this.$snotify.success(
        this.$t('mensajes.mensajesExito.crear', {
          entidad: 'Dato Extendido',
          creadoA: 'agregado',
        })
      );
      return this.form.entity;
    }
  }

  emitFormChange() {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: this.form.entity as DatoExtendidoNuevo,
      validator: this.$validator,
      isDirty: Object.keys(this.fields).some(key => this.fields[key].dirty),
    });
  }

  async handleFormChange(event: FormChangeEvent) {
    this.form = event;
    if (this.form.isDirty) {
      this.hasErrors = this.form.validator.errors.items.length > 0;
    }
  }
}
